import { useState } from 'react';

export function LatePadModal({
  name,
  onCancel,
  onSubmit,
}: {
  name: string;
  onCancel: () => void;
  onSubmit: (minutes: number) => void;
}) {
  const [val, setVal] = useState<string>('');
  function press(d: string) {
    if (d === 'back') setVal((v) => v.slice(0, -1));
    else if (d === 'clear') setVal('');
    else if (val.length < 3) setVal((v) => (v === '0' ? d : v + d));
  }
  const minutes = Number(val) || 0;
  return (
    <div className="fixed inset-0 z-40 grid place-items-center bg-slate-900/40 p-4" onClick={onCancel}>
      <div className="card w-full max-w-sm p-5" onClick={(e) => e.stopPropagation()}>
        <h2 className="text-lg font-semibold">Minutes late — {name}</h2>
        <div className="mt-3 rounded-md bg-slate-100 px-4 py-6 text-center text-5xl font-semibold tracking-wider tabular-nums">
          {val || '0'}
        </div>
        <div className="mt-3 grid grid-cols-3 gap-2">
          {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((d) => (
            <button
              key={d}
              className="btn-secondary btn-touch text-2xl"
              onClick={() => press(d)}
            >
              {d}
            </button>
          ))}
          <button className="btn-secondary btn-touch text-base" onClick={() => press('clear')}>
            CLR
          </button>
          <button className="btn-secondary btn-touch text-2xl" onClick={() => press('0')}>
            0
          </button>
          <button className="btn-secondary btn-touch text-base" onClick={() => press('back')}>
            ⌫
          </button>
        </div>
        <div className="mt-4 flex gap-2">
          <button className="btn-secondary btn-touch flex-1" onClick={onCancel}>
            Cancel
          </button>
          <button
            className="btn-primary btn-touch flex-1"
            disabled={minutes <= 0}
            onClick={() => onSubmit(minutes)}
          >
            Mark Late {minutes || 0}m
          </button>
        </div>
      </div>
    </div>
  );
}
